import CRUD from './genericCRUD'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function plantingTypes(instance) {
	return {
		/**
		 * CRUD creates  the Create,Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, 'planting_types'),

		/**
		 * @param {number} name
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllFiltered: (pageNumber, pageSize, name, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			const nameParam = name ? `name=${name}&` : ''

			return instance.get(`planting_types?${params}${nameParam}`, config)
		},

		/**
		 * @param {number} id
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		patch: (id, body, config = {}) => {
			return instance.patch(`planting_types/${id}`, body, config)
		}
	}
}
